/**
 * Email Suppression Actions Hook
 * Mutation actions for admin email suppression management.
 */

import { apiUrl } from '@config/api';
import { useAuth } from '@contexts/AuthContext';
import { useCallback, useState } from 'react';

export interface UseEmailSuppressionActionsResult {
  removeSuppression: (email: string) => Promise<{ success: boolean; error?: string }>;
  loading: boolean;
}

export function useEmailSuppressionActions(): UseEmailSuppressionActionsResult {
  const { authFetch } = useAuth();
  const [loading, setLoading] = useState(false);

  const removeSuppression = useCallback(
    async (email: string) => {
      setLoading(true);
      try {
        const res = await authFetch(apiUrl('/api/admin/email-suppressions'), {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (!res.ok) {
          return { success: false, error: data.error || 'Failed to remove suppression' };
        }
        return { success: true };
      } catch (err) {
        return { success: false, error: (err as Error).message };
      } finally {
        setLoading(false);
      }
    },
    [authFetch],
  );

  return { removeSuppression, loading };
}
